import { storyblokEditable } from '@storyblok/react';

const AnchorBlok = ({ blok }) => (
  <div className="scroll-mt-16" id={blok.anchor} {...storyblokEditable(blok)} key={blok._uid} />
);

export default AnchorBlok;
